import { APIReferenceMemberWithParameters } from '@modules/client';
import React from 'react';
import isTypeOptional from '@modules/utilities/pageBuild/isTypeOptional';
import ReferenceMemberType from './ReferenceMemberType';
import useReferenceSummaryMemberTableStylesV2 from './ReferenceSummaryMemberTableV2.styles';

interface ReferenceMemberParametersV2Props {
  parameters: APIReferenceMemberWithParameters['parameters'];
}

// This component combined ReferenceMemberParameters and ReferenceMemberParameterItem into a single component for engine revamp
export default function ReferenceMemberParametersV2({
  parameters,
}: ReferenceMemberParametersV2Props) {
  const { classes } = useReferenceSummaryMemberTableStylesV2();

  return (
    <span className={classes.parameters}>
      (
      {(parameters || []).map((param, i) => {
        const isLast = i === (parameters || []).length - 1;
        return (
          <span key={param.name} className={classes.parameter}>
            {param.name}:{' '}
            <ReferenceMemberType
              parameter={param}
              isOptional={isTypeOptional(param.type)}
              engineRevampEnabled
            />
            {!isLast && <span className={classes.parameterComma}>,</span>}
          </span>
        );
      })}
      )
    </span>
  );
}
